import { makeStyles, createStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    italicBig: {
      fontFamily: 'Lora',
      fontSize: '21px',
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'italic',
      lineHeight: 'normal',
      letterSpacing: 'normal',
      color: '#364343',
    },
    italicMedium: {
      fontFamily: 'Lora',
      fontSize: '18px',
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'italic',
      lineHeight: 'normal',
      letterSpacing: 'normal',
      color: '#364343',
    },
    checkContainer: {
      width: '100%',
      margin: '12px 0 15px 1px',
      padding: '20px 17px 20px 15px',
      borderRadius: '8px',
      border: 'solid 1px #bfcfcf',
      '&:hover': {
        background: '#efefef',
      },
    },
    checkRoot: {
      color: '#bfcfcf',
    },
    checkText: {
      fontSize: '14px',
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '1.29',
      letterSpacing: 'normal',
      color: '#626f6f',
    },
    linearRoot: {
      height: 15,
      borderRadius: 17,
      width: 270,
      margin: `${theme.spacing(3)}px 0`,
    },
    linearColorPrimary: {
      backgroundColor: '#e4ebff',
    },
    linearBar: {
      borderRadius: 5,
      backgroundColor: '#7595f0',
    },
    linearBarComplete: {
      borderRadius: 5,
      backgroundColor: '#01a7a7',
    },
  }),
);
